var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('cTable',{ref:"table",attrs:{"fields":_vm.fields,"header":_vm.header,"methods":_vm.methods,"modals":_vm.modals,"config":_vm.config},scopedSlots:_vm._u([{key:"Total",fn:function(ref){
var params = ref.params;
var visible = ref.visible;
return [(!params.write)?_c('div',{staticStyle:{"text-align":"right"}},[_vm._v("\n\t\t\t\tCNY: "),_c('span',{staticStyle:{"color":"red"}},[_vm._v(_vm._s(params.total))])]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }